import { createContext } from 'react';

const EventContext = createContext<{
    id: string,
    slug: string,
    quiz: boolean,
    forum: boolean,
    presentationsWithQuestions: Array<string>,
    presentationsWithResults: Array<string>,
    setPresentationData: ({
        presentationsWithQuestions,
        presentationsWithResults
    }:{
        presentationsWithQuestions: Array<string>,
        presentationsWithResults: Array<string>
    }) => void,
}>({
    id: '',
    slug: '',
    quiz: false,
    forum: false,
    presentationsWithQuestions: [],
    presentationsWithResults: [],
    setPresentationData: ({ presentationsWithQuestions, presentationsWithResults }) => {},
});

export default EventContext;
